import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=3c07a7c3&"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=ts&"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports